import { useState } from "react";
import { Card, CardBody, Collapse } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { FilterHeading, FindJobs } from "../../../../Constant";
import HeaderWithIcon from "../HeaderWithIcon";
import FilterCheckBox from "./FilterCheckBox";
import SearchAndMap from "./SearchAndMap";

const Filter = () => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <div className="accordion" id="accordionExample">
      <Card>
        <HeaderWithIcon heading={FilterHeading} isOpen={isOpen} setIsOpen={setIsOpen}/>
        <Collapse isOpen={isOpen}>
          <CardBody className="filter-cards-view animate-chk">
            <SearchAndMap />
            <FilterCheckBox />
            <Btn className="text-center w-100" color="primary" >{FindJobs}</Btn>
          </CardBody>
        </Collapse>
      </Card>
    </div>
  );
};

export default Filter;
